import { CASINO_HRY_CATEGORY_PATH, CASINO_HRY_LOBBY_PATH } from 'nike-ui/src/components/casino/paths';
import { COMMUNITY_PATHS } from 'nike-ui/src/components/betbook/paths';

export default [
    { from: '/klub-nike/registracia', to: '/registracia' },
    { from: '/kasino/clanky/:articleCode/', to: '/casino/clanky/:articleCode/' },
    { from: '/kasino/detail/:gameId/', to: '/casino/detail/:gameId/' },
    { from: '/kasino', to: '/casino/' },
    { from: '/casino/iforium/kategoria/:categorySlug?', to: CASINO_HRY_CATEGORY_PATH },
    { from: '/casino/iforium', to: CASINO_HRY_LOBBY_PATH },
    { from: '/virtualne-hry/vysledky', to: '/vysledky' },
    { from: '/live/vysledky', to: '/vysledky' },
    { from: '/tipovanie/vysledky', to: '/vysledky' },
    { from: '/tipovanie/kontrola-tiketu', to: '/kontrola-tiketu' },
    { from: '/info/mapa-pobociek', to: '/mapa-pobociek' },
    { from: '/info/kontakty', to: '/kontakty' },
    { from: '/live', to: '/live-stavky' },
    { from: '/betbook*', to: COMMUNITY_PATHS.COMMUNITY_LOBBY.path }
];
